import React, { useState, useRef } from 'react';
import InfoTracking from '@app/components/common/InfoTracking';
import { Button, Col, Switch, DatePicker, Drawer, Form, Input, Row, Select, InputNumber, Space, message, Modal } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import {insertPrimaRiesgo, getPrimaRiesgo, updatePrimaRiesgo} from '../../../../../apis/RegistroPatronalApi';
import moment from 'moment';
import './styles.scss';

const App = ({title, registroPatronalId, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [descripcion, setDescripcion] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [initialValues, setInitialValues] = useState(null);

    const handleOk = async () => {

        try {
            const values = await form.validateFields();
            if(!values) return;
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            return;
        }

        const fields = form.getFieldsValue()
        var defaultValue = {
        }

        let success = false;
        if(ID > 0){
            const payload = {
                id: ID,
                registro_patronal_id: registroPatronalId,
                ...defaultValue,
                ...fields
            }
            const response = await updatePrimaRiesgo(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se guardo correctamente la linea!');
            }
        }else{
            const payload = {
                registro_patronal_id: registroPatronalId,
                ...fields
            }
            const response = await insertPrimaRiesgo(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se guardo correctamente la linea!');
            }
        }
        
        if(success){
            setShowModal(false);
            finish(true);
        }
    }

    const onClose = ()=>{
        setShowModal(false);
        finish(false);
    }

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    React.useEffect(() => {
        setID(id);
    }, [id]);


    const effectRan = useRef(false);
    React.useEffect(() => {

      if (!effectRan.current) {
        (async ()=>{
            if(ID > 0){
                await refreshData();
            }else{
                setInitialValues({
                    activo: true
                });
            }
        })()
      }
    
      return () => effectRan.current = true;
    }, [ID]);

    const refreshData = async ()=> {
        if(ID > 0){
            const response = await getPrimaRiesgo(ID);
            if(response.ok){
                let item = response.payload;
                if(item.fecha){
                    item.fecha = moment(item.fecha, 'YYYY-MM-DD');
                }
                setInitialValues(item);
            }
        }else{
            setInitialValues({
                activo: true
            });
        }
    }

  return (
    <>
      <Drawer
        title={title}
        width={720}
        placement={"right"}
        onClose={onClose}
        open={open}
        closable={true}
        height={'80%'}
        onFinish={handleOk}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
        extra={[
            <Space>
                {ID && <InfoTracking entity={'ConfiguracionPeriodoDetalle'} entityId={ID}/>}
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>
        ]}
      >
        {
            initialValues && 
            <Form layout="vertical" form={form}                         requiredMark
            onFinish={handleOk} initialValues={initialValues}>
                <Row gutter={16}>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="prima_de_riesgo"
                            label="Prima de Riesgo"
                            rules={[
                            {
                                required: true,
                                message: 'Por favor agrega la actividad económica',
                            },
                            ]}
                        >
                            <InputNumber placeholder="Por favor agrega la actividad económica" />
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="fecha"
                            label="Fecha"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor agrega una fecha',
                                },
                                ]}
                        >
                            <DatePicker placeholder="DD/MM/YYYY"  style={{width: '100%',}} format={'DD/MM/YYYY'}/>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="activo"
                            label="Activo"
                            >
                            <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        }
      </Drawer>
    </>
  );
};
export default App;